import { all, call } from 'redux-saga/effects';

import activityProgressSaga from './activity-progress';
import plainFinishedToastSaga from './plain-finished-toast';

export default function* initActivitySagas() {
    yield all([call(plainFinishedToastSaga), call(activityProgressSaga)]);
}
